<template>
  <v-slide-y-transition>
    <div class="px-3 pt-8" v-if="request">
      <section>
        <RequestSummary :request="request" />
      </section>

      <section v-if="request.status === 'init'">
        <RequestCancelButton :uuid="uuid" @update="fetchData" />
      </section>

      <section>
        <RequestFile :uuid="uuid" :request="request" />
      </section>
    </div>
  </v-slide-y-transition>
</template>

<script>
export default {
  props: {
    uuid: {
      Type: String,
      required: true,
    },
  },
  components: {
    RequestSummary: () => import('@/components/credit-pay/request/detail/RequestSummary.vue'),
    RequestFile: () => import('@/components/credit-pay/request/detail/RequestFile.vue'),
    RequestCancelButton: () =>
      import('@/components/credit-pay/request/detail/RequestCancelButton.vue'),
  },
  data() {
    return {
      request: null,
    }
  },
  async created() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      const { data: request } = await this.$defaultApi.getCreditPaysRequestDetail(this.uuid)
      this.request = request
    },
  },
}
</script>

<style lang="scss" scoped>
section:not(:last-of-type) {
  margin-bottom: 24px;
}
</style>
